import React, { useEffect, useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import IconSearchDesktop from '../../containers/TopbarContainer/Topbar/TopbarSearchForm/IconSearchDesktop';

export const ALGOLIA_SEARCH_PAGE = "AlgoliaSearchPage";
export const ALGOLIA_SEARCH_TYPE_PAGE = "AlgoliaSearchTypePage";
const indexName = process.env.REACT_APP_ALGOLIA_LISTING_INDEX;

const AlgoliaAutocomplete = props => {
  const history = useHistory();
  const routes = useRouteConfiguration();

  const { className, currentSearchParams, params } = props;
  const productType = (params && params.type) || '';
  const queryParams =
    currentSearchParams?.searchState?.query ||
    currentSearchParams?.searchState?.[indexName]?.query ||
    '';
  const [searchTerm, setsearchTerm] = useState(queryParams);

  useEffect(() => {
    if (queryParams) {
      setsearchTerm(queryParams);
    }
  }, [queryParams]);


  const onSubmit = () => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("category");
    }

    const pageType = productType ? ALGOLIA_SEARCH_TYPE_PAGE : ALGOLIA_SEARCH_PAGE;
    const pathParams = productType ? { type: productType, mainType: params?.mainType } : {};
    const queryParams = searchTerm ? { query: searchTerm } : {};

    const searchUrl = createResourceLocatorString(pageType, routes, pathParams, queryParams);

    history.push(searchUrl);
  };

  const handleInputChange = e => {
    const value = e.currentTarget.value;
    setsearchTerm(value);
  };

  const handleIconClick = e => {
    if (searchTerm.trim()) {
      onSubmit();
    }
  };
  return (
    <>
      <input
        value={searchTerm}
        type="text"
        className={className}
        name="keywords"
        placeholder="Search..."
        onChange={handleInputChange}
        onKeyUpCapture={e => {
          if (e.key === 'Enter') {
            onSubmit();
          }
        }}
      />
      <button onClick={handleIconClick}>
        <IconSearchDesktop />
      </button>
    </>
  );
};

export default withRouter(AlgoliaAutocomplete);
